import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ScanHistory = ({ scanHistory, onSelectVin, onClearHistory }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!scanHistory || scanHistory?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border p-6 text-center">
        <Icon name="History" size={32} className="text-muted-foreground mx-auto mb-3" />
        <p className="text-sm text-muted-foreground">Noch keine VIN-Codes gescannt</p>
      </div>
    );
  }

  const displayedHistory = isExpanded ? scanHistory : scanHistory?.slice(0, 3);

  return (
    <div className="bg-card rounded-lg border border-border">
      <div className="p-4 border-b border-border flex items-center justify-between">
        <div className="flex items-center">
          <Icon name="History" size={18} className="text-primary mr-2" />
          <h3 className="text-sm font-semibold text-foreground">Scan-Verlauf</h3>
          <span className="ml-2 text-xs bg-muted text-muted-foreground px-2 py-1 rounded-full">
            {scanHistory?.length}
          </span>
        </div>
        
        {scanHistory?.length > 0 && (
          <div className="flex items-center space-x-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => window.location.reload()}
              iconName="RefreshCw"
              iconPosition="left"
              className="text-muted-foreground hover:text-foreground"
            >
              Aktualisieren
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearHistory}
              iconName="Trash2"
              iconPosition="left"
              className="text-destructive hover:text-destructive"
            >
              Löschen
            </Button>
          </div>
        )}
      </div>
      <div className="p-4 space-y-3">
        {displayedHistory?.map((scan, index) => (
          <div
            key={index}
            className="flex items-center justify-between p-3 bg-muted rounded-lg hover:bg-muted/80 transition-colors cursor-pointer"
            onClick={() => onSelectVin(scan)}
          >
            <div className="flex-1 min-w-0">
              <div className="flex items-center mb-1">
                <span className="text-sm font-medium text-foreground">
                  {scan?.make} {scan?.model}
                </span>
                <span className="ml-2 text-xs text-muted-foreground">
                  {scan?.year}
                </span>
              </div>
              <p className="text-xs font-mono text-muted-foreground truncate">
                {scan?.vin}
              </p>
              <p className="text-xs text-muted-foreground">
                {new Date(scan.timestamp)?.toLocaleString('de-DE', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </p>
            </div>
            
            <div className="flex items-center space-x-2 ml-3">
              <div className="flex flex-col items-end">
                {scan?.hasOrder ? (
                  <div className="flex items-center space-x-1 mb-1">
                    <div className="w-2 h-2 bg-success rounded-full"></div>
                    <span className="text-xs text-success font-medium">Auftrag erstellt</span>
                  </div>
                ) : (
                  <div className="flex items-center space-x-1 mb-1">
                    <div className="w-2 h-2 bg-muted-foreground rounded-full"></div>
                    <span className="text-xs text-muted-foreground">Kein Auftrag</span>
                  </div>
                )}
                <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
              </div>
            </div>
          </div>
        ))}

        {scanHistory?.length > 3 && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsExpanded(!isExpanded)}
            iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
            iconPosition="right"
            className="w-full"
          >
            {isExpanded ? 'Weniger' : `${scanHistory?.length - 3} weitere`} anzeigen
          </Button>
        )}
      </div>
    </div>
  );
};

export default ScanHistory;